import React, { useState, useEffect } from "react";
import { Card, CardBody, CardTitle, Progress, Spinner } from "reactstrap";

const TopCities = () => {
  const [citiesData, setCitiesData] = useState([]);
  const [topCity, setTopCity] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const colors = ["primary", "success", "warning", "danger", "info"];

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        const userId = authUser?.ID;
        const isAdmin = authUser?.Users_Type_ID === 3; // 3: Admin

        if (!userId) {
          setIsLoading(false);
          return;
        }

        // Filtre kurgusu: Admin ise filtre yok, sürücü ise sadece kendi ID'si
        const filterStr = isAdmin ? "" : `$filter=Users_ID eq ${userId}&`;
        
        const response = await fetch(
          `https://hiflowapi.stechomeyazilim.info/Advert?${filterStr}$expand=Advert_Location&$top=100&$orderby=ID desc`
        );
        const result = await response.json();

        if (result && result.value) {
          const cityCounts = {};
          let totalCount = 0;

          result.value.forEach(advert => {
            const locationArr = advert.Advert_Location || [];
            locationArr.forEach(loc => {
              const city = loc.Start_City_Code || (loc.Advert_Location_StartAddress ? loc.Advert_Location_StartAddress.split(',')[0].trim() : null);
              
              if (city) {
                  cityCounts[city] = (cityCounts[city] || 0) + 1;
                  totalCount++;
              }
            });
          });

          const sortedCities = Object.keys(cityCounts)
            .map(city => ({
              location: city,
              value: cityCounts[city],
            }))
            .sort((a, b) => b.value - a.value)
            .slice(0, 5);

          const formattedCities = sortedCities.map((item, index) => ({
            ...item,
            progress: {
              value: totalCount > 0 ? Math.round((item.value / totalCount) * 100) : 0,
              color: colors[index % colors.length]
            }
          }));

          if (formattedCities.length > 0) {
            setTopCity(formattedCities[0]); 
            setCitiesData(formattedCities.slice(1)); 
          }
        }
      } catch (error) {
        console.error("Şehir istatistikleri çekilirken hata oluştu:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchLocations();
  }, []);

  // Rol kontrolü için tekrar çekiyoruz
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = authUser?.Users_Type_ID === 3; // 3: Admin

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle className="mb-4">
            {isAdmin ? "Sistem Genelinde Popüler Kalkış Noktaları" : "Popüler Kalkış Noktalarınız"}
          </CardTitle>
          
          {isLoading ? (
             <div className="text-center py-5">
               <Spinner color="primary" /> <p className="mt-2 text-muted">Hesaplanıyor...</p>
             </div>
          ) : topCity ? (
            <>
              <div className="text-center">
                <div className="mb-4">
                  <i className="bx bx-map-pin text-primary display-4" />
                </div>
                <h3>{topCity.value} Taşıma</h3>
                <p className="text-uppercase fw-medium text-muted">{topCity.location}</p>
              </div>

              <div className="table-responsive mt-4">
                <table className="table align-middle table-nowrap mb-0">
                  <tbody>
                    {citiesData.map((item, index) => (
                        <tr key={index}>
                          <td style={{ width: "30%" }}>
                            <p className="mb-0 fw-medium text-uppercase">{item.location}</p>
                          </td>
                          <td style={{ width: "25%" }}>
                            <h5 className="mb-0">{item.value}</h5>
                          </td>
                          <td>
                            <Progress
                              value={item.progress.value}
                              color={item.progress.color}
                              className="bg-transparent progress-sm"
                              size="sm"
                            />
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <div className="text-center text-muted py-5">
                {isAdmin ? "Sistemde henüz lokasyon verisi bulunmuyor." : "Henüz yeterli lokasyon veriniz bulunmuyor."}
            </div>
          )}
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default TopCities;